import { MenuItem } from '../context-menu/menuItem';
import { OfferEntryData, GridRow } from '../../../core/models/offerEntryData';

export class GridHelper {

    public static isLeftMouseButton(event) {
        if ('buttons' in event) {
            return event.buttons === 1;
        } else if ('which' in event) {
            return event.which === 1;
        } else {
            return event.button === 1;
        }
    }

    public static isRightMouseButton(event): boolean {
        if ("which" in event)  // Gecko (Firefox), WebKit (Safari/Chrome) & Opera
            return event.which == 3;
        else if ("button" in event)  // IE, Opera
            return event.button == 2;
        else
            return false;
    }

    public static sortData(offerEntryData: OfferEntryData, subrow: number, column: number, ascending: boolean) {
        var tempSort: GridRow[] = [];
        if (column >= 0) {
            if (ascending)
                tempSort = offerEntryData.gridRows.sort((n1, n2) => n1.dataRows[subrow].dataValues[column] - n2.dataRows[subrow].dataValues[column]);
            else
                tempSort = offerEntryData.gridRows.sort((n1, n2) => n2.dataRows[subrow].dataValues[column] - n1.dataRows[subrow].dataValues[column]);
        }
        else {
            if (ascending)
                tempSort = offerEntryData.gridRows.sort((n1, n2) => n1.dataRows[subrow].rowSum - n2.dataRows[subrow].rowSum);
            else
                tempSort = offerEntryData.gridRows.sort((n1, n2) => n2.dataRows[subrow].rowSum - n1.dataRows[subrow].rowSum);
        }
        offerEntryData.sortedGridRows = [];
        tempSort.forEach(gridRow => {
            if (!gridRow.isSubGrid && !gridRow.isTotalRow) {
                offerEntryData.sortedGridRows.push(gridRow);
                if (gridRow.subGridRows.length > 0) {
                    tempSort.forEach(subGridRow => {
                        if (subGridRow.isSubGrid && gridRow.subGridRows.indexOf(subGridRow.id) >= 0)
                            offerEntryData.sortedGridRows.push(subGridRow);
                    });
                }
            }
        });
        tempSort.forEach(gridRow => {
            if (gridRow.isTotalRow) {
                offerEntryData.sortedGridRows.push(gridRow);
            }
        });
    }

    public static initialiseSort(offerEntryData: OfferEntryData) {
        if (offerEntryData.gridRows.length > 0) {
            offerEntryData.sortOptions = [];
            offerEntryData.gridRows[0].dataRows.forEach((dataRow, i) => {
                offerEntryData.sortOptions.push({ name: dataRow.name, dataVal: i, function: GridHelper.sortData });
            });
            offerEntryData.sortedGridRows = offerEntryData.gridRows;  // default sort is just as per data order
        }
    }

}




// WEBPACK FOOTER //
// ./src/app/shared/components/offer-entry-grid/gridHelper.ts